import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { Select } from "@/components/elements/Select";
import { InputDatePicker } from "@/components/elements/InputDatePicker";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { CheckboxGroup } from "@/components/elements/CheckboxGroup";
import { useEnum } from "@/api/services/global/enum";
import dayjs from "dayjs";
import { text } from "@/theme/colors";

type TJobStatusProps = {
  isDraft?: boolean;
};

export const JobStatus: FC<TJobStatusProps> = ({ isDraft: _isDraft }) => {
  const methods = useFormContext<TJobForm>();
  const { control, setValue } = methods;
  const { data: jobStatusOptions } = useEnum("EJobStatus");
  const { data: jobTagOptions } = useEnum("EJobTag");

  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="ステータス状況" /> } showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormField control={control} name="status">
              <Select placeholder="選択してください" options={jobStatusOptions} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="tag">
              <CheckboxGroup
                flexDirection="row"
                rowGap={1}
                columnGap={3}
                options={jobTagOptions}
                onChange={(value) => {
                  const last = value.length > 0 ? String(value[value.length - 1]) : null;
                  setValue("tag", last ? [last] : null);
                }}
              />
              <Typography variant="cap12" color={text.secondary}>新着求人は2週間「NEW」のタグが付与されます。</Typography>
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="startDate">
              <InputDatePicker placeholder="1990/06/25" minDate={dayjs("1900/01/01")} maxDate={dayjs("2099/12/31")} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="endDate">
              <InputDatePicker placeholder="1990/06/25" minDate={dayjs("1900/01/01")} maxDate={dayjs("2099/12/31")} />
            </FormField>
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="statusMemo">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
